module.exports = __webpack_public_path__ + "static/media/deloitte.a70abe66.png";